import { Button } from '@/components/ui/button'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useProductWornTogether } from '@/hooks/react-query/products/use-product'
import { useTranslations } from 'next-intl'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { ProductInfoSuggest } from './module'
import { ProductInfoSuggestAllModal } from './product-info-suggest-all-modal'

export const ProductSuggestCarousel = () => {
  const t = useTranslations('product_detail.title')
  const { product } = useProductDetailSafe()

  const searchParams = useSearchParams()
  const previewToken = searchParams.get('preview')
  const { data: wornTogetherProducts } = useProductWornTogether(
    product?.id,
    previewToken || ''
  )
  const [isModalOpen, setIsModalOpen] = useState(false)
  if (!wornTogetherProducts || !wornTogetherProducts.length) return null

  return (
    <div
      className='mt-2.5 border-t border-t-neutral-200 pt-4 lg:mt-4'
      data-tracking-level-2={`Matchinglook_${product?.gender_type}`}
    >
      <div className='mb-2 flex items-center justify-between'>
        <h2 className='font-sans text-sm font-bold uppercase leading-4.5 text-neutral-900 lg:text-base lg:leading-5'>
          {t('worn_together')}
        </h2>
        <Button
          variant='link'
          className='font-pangea text-xs normal-case text-neutral-900 underline md:hidden'
          onClick={() => setIsModalOpen(true)}
        >
          Xem tất cả
        </Button>
      </div>
      <Carousel
        opts={{
          align: 'start',
          duration: 50,
          slidesToScroll: 1,
          skipSnaps: true,
        }}
        className='w-full'
      >
        <CarouselContent>
          {wornTogetherProducts?.map((product) => (
            <CarouselItem
              key={product.id}
              className='basis-5/12 will-change-transform sm:basis-1/4'
              data-product-id={product.id}
            >
              <ProductInfoSuggest.Item product={product} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
      <ProductInfoSuggestAllModal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
        products={wornTogetherProducts || []}
        previewToken={previewToken || ''}
      />
    </div>
  )
}

const CarouselNavigation = () => {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-4 top-1/2 h-8 w-8 -translate-y-1/2 sm:-left-4 xl:-left-10'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-4 top-1/2 h-8 w-8 -translate-y-1/2 sm:-right-4 xl:-right-10'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
